import React, {useState, useEffect} from 'react';
import {useParams, Link, useHistory} from 'react-router-dom';
import {userProfile} from '../../../../shared/models/UserProfile';
import {putUserFirst} from '../../../../shared/utils/Helpers';
import DetailHeader from '../DetailHeader';
import Loading from '../Loading';
import styles from './ChallengeDetail.module.css';
import AvatarList from '../AvatarList';
import {rwbApi} from '../../../../shared/apis/api';
import ChallengeProgressBar from './ChallengeProgressBar';
import {
  CHALLENGE_ERRORS,
  JOIN_CHALLENGE_ERROR,
  LOAD_CHALLENGE_ERROR,
} from '../../../../shared/constants/ErrorMessages';
import {isDev} from '../../../../shared/utils/IsDev';
import RankingRow from './RankingRow';
import FeedList from '../feed/FeedList';
import CreatePostButton from '../feed/CreatePostButton';
import {hasReachedBottom} from '../../BrowserUtil';
import {
  earnedBadge,
  getChallengeStatusText,
} from '../../../../shared/utils/ChallengeHelpers';
import {errorAlert} from '../../../../shared/utils/ErrorAlert';
import { projectConfig } from '../../../../shared/project-info/projectConfig';
import moment from 'moment';
import {GROUP_EVENT_OPTIONS} from '../../../../shared/constants/EventFilters';
import EventsIcon from '../svgs/EventsIcon';
import { CHALLENGE_TYPES } from '../../../../shared/constants/ChallengeTypes';
import CustomModal from '../events/CustomModal';
import CustomButton from '../CustomButton';
import AddHydrationModal from './AddHyrationModal.react';
import RWBModal from '../RWBModal.web';
import { globalCanCreatePost } from '../../../../shared/utils/FeedHelpers';

const ChallengeDetail = ({updateJoined}) => {
  const {challengeId} = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState();
  const [endTime, setEndTime] = useState();
  const [startTime, setStartTime] = useState();
  const [coverPhoto, setCoverPhoto] = useState();
  const [description, setDescription] = useState();
  const [copyMessage, setCopyMessage] = useState();
  const [eventCount, setEventcount] = useState(0);
  const [changingChallengeStatus, setChangingChallengeStatus] = useState(false);
  const [joinedChallenge, setJoinedChallenge] = useState(false);
  const [totalUsers, setTotalUsers] = useState([]);
  const [totalUsersCount, setTotalUsersCount] = useState(0);
  const [badgeURL, setBadgeUrl] = useState();
  const [hasBadge, setHasBadge] = useState(false);
  const [badgeName, setBadgeName] = useState();
  const [progress, setProgress] = useState(0);
  const [goal, setGoal] = useState(0);
  const [place, setPlace] = useState(0);
  const [checkin_event_category, setCheckinEventCategory] = useState();
  const [metric, setMetric] = useState('');
  const [links, setLinks] = useState();
  const [leaderboard, setLeaderboard] = useState([]);
  const [feed, setFeed] = useState([]);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [retrievedLastPost, setRetrievedLastPost] = useState(false);
  const [hydrationModalVisible, setHydrationModalVisible] = useState(false);

  const user = userProfile.getUserProfile();
  const history = useHistory();

  const viewEventsForCategory = () => {
    const filter_category = checkin_event_category === null ? 'all-activities' : checkin_event_category;
    // NavigationService.navigate('EventsScreen', {localEventCategory: filter_category, virtualEventCategory: filter_category});
  }

  const copyChallengeURL = () => {
    // todo, figure out url
    navigator.clipboard.writeText(
      isDev()
        ? `${projectConfig.stagingURL}challenges/${challengeId}`
        : `${projectConfig.prodURL}challenges/${challengeId}`,
    );
    setCopyMessage('Copied!');
    setTimeout(() => {
      setCopyMessage('');
    }, 3000);
  };

  
  const updateRankAndParticipants = (withRetry = false) => {
    const currentProgress = progress;
    
    Promise.all([loadChallengeRank(), loadTopParticipants()]).then(
      ([rank, topParticipants]) => {
        setPlace(rank.rank);
        setProgress(rank.score);
        setLeaderboard(topParticipants.data || []);
        setChangingChallengeStatus(false);
        
        // Only make second request if withRetry is true AND progress has not changed. This does not happen every time.
        if (withRetry && rank.score == currentProgress) {
          
          setTimeout(() => {
            Promise.all([loadChallengeRank(), loadTopParticipants()]).then(
              ([freshRank, freshTopParticipants]) => {
                setPlace(freshRank.rank);
                setProgress(freshRank.score);
                setLeaderboard(freshTopParticipants.data || []);
              },
            );
          }, 3000);
        }
      },
    );
  };

  const joinChallenge = () => {
    if (!changingChallengeStatus) {
      setChangingChallengeStatus(true);
      userJoined();
      rwbApi
        .joinChallenge(challengeId)
        .then(() => {
          // update the active challenges list on the challenges tab
          if (updateJoined) updateJoined();
          updateRankAndParticipants();
        })
        .catch(() => {
          userLeft();
          setJoinedChallenge(false);
          errorAlert(CHALLENGE_ERRORS.JOIN);
          setChangingChallengeStatus(false);
        });
    }
  };

  const userJoined = () => {
    setJoinedChallenge(true);
    const user = userProfile.getUserProfile();
    let userList = Array.from(putUserFirst(totalUsers, joinedChallenge));
    userList.unshift(user);
    setTotalUsers(userList);
    setTotalUsersCount(totalUsersCount + 1);
  };

  const leaveChallenge = () => {
    if (!changingChallengeStatus) {
      setChangingChallengeStatus(true);
      userLeft();
      rwbApi
        .leaveChallenge(challengeId)
        .then((result) => {
          if (updateJoined) updateJoined();
          loadTopParticipants().then((topParticipants) => {
            setLeaderboard(topParticipants.data || []);
            setChangingChallengeStatus(false);
          });
        })
        .catch((err) => {
          setChangingChallengeStatus(false);
          console.warn(err);
          userJoined();
          errorAlert(CHALLENGE_ERRORS.LEAVE);
        });
    }
  };

  const userLeft = () => {
    setJoinedChallenge(false);
    let userList = Array.from(putUserFirst(totalUsers, joinedChallenge));
    userList.shift();
    setTotalUsers(userList);
    setTotalUsersCount(totalUsersCount - 1);
  };

  const viewEvents = () => {
    history.push({
      pathname: `${challengeId}/events`,
      state: {
        challengeName: name,
      },
    });
  };

  const userJoinedChallenge = () => {
    return rwbApi
      .hasJoinedChallenge(challengeId)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        console.warn(err);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    Promise.all([
      loadChallenge(),
      userJoinedChallenge(),
      loadChallengeRank(),
      loadTopParticipants(),
      loadChallengeFeed(),
      getChallengeParticipants(),
    ])
      .then(
        ([challenge, joined, rank, topParticipants, feed, participants]) => {
          setBadgeName(challenge.badge_name);
          setBadgeUrl(challenge.badge_image_url);
          setStartTime(challenge.start_date);
          setEndTime(challenge.end_date);
          setName(challenge.name);
          setDescription(challenge.description);
          setEventcount(challenge.event_count);
          setCoverPhoto(challenge.cover_image_url);
          setGoal(challenge.goal);
          setMetric(challenge.required_unit);
          setCheckinEventCategory(challenge.checkin_event_category);
          setLinks(challenge.links || []);
          setJoinedChallenge(joined);
          setIsLoading(false);
          setPlace(rank.rank);
          setProgress(rank.score);
          setLeaderboard(topParticipants.data || []);
          setFeed([...feed.data?.results]);
          setTotalUsers(participants.participants);
          setTotalUsersCount(participants.count);
        },
      )
      .catch((err) => {
        errorAlert(CHALLENGE_ERRORS.LOAD);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const getChallengeParticipants = () => {
    return rwbApi
      .getChallengeParticipants(challengeId)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        console.warn(err);
      });
  };

  const loadChallenge = () => {
    return rwbApi
      .getChallenge(challengeId)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        console.warn(err);
      });
  };

  const loadChallengeRank = () => {
    return rwbApi
      .getLeaderboardRank(challengeId)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        console.warn(err);
      });
  };

  const loadTopParticipants = () => {
    return rwbApi
      .getLeaderboardTop(challengeId)
      .then((result) => {
        return result;
      })
      .catch((err) => {
        console.warn(err);
      });
  };

  const loadChallengeFeed = (offset) => {
    setFeed([]);
    return rwbApi
      .getChallengeFeed(challengeId, offset)
      .then((result) => {
        return result;
      })
      .catch((err) => {});
  };

  const handleNewPost = () => {
    loadChallengeFeed().then((result) => {
      setFeed([...result.data.results]);
    });
  };

  const trackScrolling = (event) => {
    event.preventDefault();
    const wrappedElement = document.getElementById('root');
    if (hasReachedBottom(wrappedElement)) {
      loadMorePosts();
    }
  };

  const loadMorePosts = () => {
    // only try to retrieve more from the feed if it is not already retrieving
    if (!isLoadingMore) {
      const posts = feed;
      const lastPost = posts[posts.length - 1];
      if (!retrievedLastPost && challengeId && lastPost?.id) {
        setIsLoadingMore(true);
        rwbApi.getChallengeFeed(challengeId, lastPost.id).then((result) => {
          if (result.data.results.length > 0) {
            setFeed([...feed, ...result.data.results]);
            setIsLoadingMore(false);
          } else {
            setIsLoadingMore(false);
            setRetrievedLastPost(true);
          }
        });
      } else {
        setIsLoadingMore(false);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', trackScrolling);
    return () => {
      window.removeEventListener('scroll', trackScrolling);
    };
  }, [loadMorePosts]);

  const eventCategoryDisplay = GROUP_EVENT_OPTIONS[checkin_event_category]?.display || 'Any'; // 'Any' corresponds to all-activities that's hardcoded throughout.

  const leaveChallengeButton = (widthPercentage) => {
    return (
      <div
      onClick={leaveChallenge}
      className={`${styles.button} ${styles.whiteButton}`}
      style={{
        width: widthPercentage,
        opacity: changingChallengeStatus ? 0.5 : null,
      }}>
      {widthPercentage === '25%' ? 'Leave' : 'Leave Challenge'}
    </div>
    )
  }

  const leaveChallengeSection = () => {
    if (metric === CHALLENGE_TYPES.checkins) {
      return (
        <>
           <div className={styles.instructionsWrapper}>
              {/* TODO: Link to Virtual Events matching checkin challenge type */}
              <Link className={styles.eventIconWrapper}>
                <EventsIcon tintColor="white"/>
              </Link>
              <div className={styles.instructions}>Check in to <span>{eventCategoryDisplay}</span> events to complete this challenge</div>
            </div>
            {!moment().utc().isAfter(moment.utc(endTime)) &&  leaveChallengeButton('25%')}
        </>
      )
    } else {
      return (
        <div className={styles.activityLeaveButtonsContainer}>
          <div  onClick={() => {
          history.push({pathname: '/workoutlogs', state: {
            type: metric,
            challengeId,
          }})
        }} className={`${styles.button} ${styles.whiteButton}`} style={{width: '40%'}}>
            See Activity
          </div>
          {!moment().utc().isAfter(moment.utc(endTime)) && leaveChallengeButton('50%')}
        </div>
       
      )
    }
  }

  return (
    <>
      {isLoading ? (
        <Loading size={100} color={'var(--white)'} loading={isLoading} right />
      ) : (
        <>
          <DetailHeader
            imageAlt={'Challenge Cover Photo'}
            primaryImg={coverPhoto}
            backupImg={null}
            goBack={history.goBack}
            copyClick={copyChallengeURL}
            copyMessage={copyMessage}
          />
          <div className={styles.challengeDetailContainer}>

            <div
              className={styles.badgeContainer}
              style={{
                backgroundColor: earnedBadge(progress, goal)
                  ? 'var(--gold)'
                  : null,
              }}>
              <img
                alt={`${badgeName} badge`}
                className={styles.badgeIcon}
                src={badgeURL}
              />
            </div>

            {joinedChallenge && goal && goal > 0 ? (
              <div className={styles.progressWrapper}>
                <ChallengeProgressBar
                  progress={progress}
                  goal={goal}
                  place={place}
                  metric={metric}
                  challengeEnd={getChallengeStatusText(startTime, endTime)}
                />
              </div>
            ) : null}
            <div>
              <h1>{name}</h1>
              <h5>{getChallengeStatusText(startTime, endTime)}</h5>
            </div>
            <p className={styles.description}>{description}</p>
            <div className={styles.buttonContainer} style={{flexDirection: metric === CHALLENGE_TYPES.checkins ? 'row' : 'column'}}>
              {(joinedChallenge) 
                ? 
                <>
                  {(metric === CHALLENGE_TYPES.hydration) && <div
                    className={styles.button}
                    onClick={() => setHydrationModalVisible(true)}
                    style={{marginBottom: 10, width: '100%'}}
                    >
                      Add Hydration
                    </div>
                  }
                  {leaveChallengeSection()}
                </>
               : (
                <>
                  <div
                    className={styles.button}
                    style={{opacity: changingChallengeStatus ? 0.5 : null}}
                    onClick={joinChallenge}>
                    Join Challenge
                  </div>
                </>
              )}
            </div>
           {totalUsers.length>0 && <div className={styles.avatarContainer}>
              <Link
                to={{
                  pathname: `/challenges/${challengeId}/participants`,
                  state: {
                    challengeName: name,
                    challengeId: challengeId,
                    participants: totalUsers,
                    totalUsersCount: totalUsersCount??0,
                  },
                }}>
                <AvatarList
                  avatars={putUserFirst(totalUsers, joinedChallenge)}
                  total_count={totalUsersCount??0}
                />
              </Link>
            </div>}
          </div>
          {parseInt(goal) === 0 && place && place > 5 ? (
            <div className={styles.leaderboardContainer}>
              <RankingRow
                place={place}
                progress={progress}
                metric={metric}
                ignoreEmphasis={true}
              />
            </div>
          ) : null}
          {leaderboard.length > 0 && (
            <div className={styles.leaderboardContainer}>
              <h3>Leaderboard</h3>
              {leaderboard.slice(0, 5).map((ranking, i) => {
                return (
                  <RankingRow
                    key={`ranked-row-${i}`}
                    place={ranking.rank}
                    user={ranking.user}
                    progress={ranking.score}
                    metric={metric}
                  />
                );
              })}
              <div style={{display: 'flex', justifyContent: 'center'}}>
                <Link
                  className={styles.seeMoreLink}
                  to={{
                    pathname: `/challenges/${challengeId}/leaderboard`,
                    state: {
                      challengeId: challengeId,
                      challengeName: name,
                      metric: metric,
                      rank: place,
                      data: leaderboard,
                    },
                  }}>
                  <p>See More</p>
                </Link>
              </div>
            </div>
          )}

          {feed.length > 0 && (
            <FeedList userFeed={feed} mergeNewPost={handleNewPost} />
          )}
          {globalCanCreatePost(user) &&
            joinedChallenge &&
            !changingChallengeStatus &&
            (
              <CreatePostButton
                type={'challenge'}
                challengeID={challengeId}
                mergeNewPost={handleNewPost}
              />
            )}
        <RWBModal bottomSheet={true} open={hydrationModalVisible} closeModal={() => setHydrationModalVisible(false)}>
          <AddHydrationModal 
            onRequestClose={() => setHydrationModalVisible(false)}
            onSuccessfulSubmit={() => updateRankAndParticipants(true)}
          />
        </RWBModal>
        </>
      )}
    </>
  );
};

export default ChallengeDetail;
